var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.dataUser)?_c('header-page-derek',{attrs:{"title":'Hola ' + _vm.dataUser.persona.nombres + ', que bueno tenerte de vuelta',"skeleton":false}}):_vm._e(),_c('div',{staticClass:"container-menu-nav-profile",class:_vm.dataUser ? '' : 'pt-3'},[_c('menu-profile-desktop'),_c('menu-profile-movil')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }